export default __webpack_public_path__ + "static/media/how-it-works-3.352724fd.png";